@let e = emails(); @if (e.length > 0) {
<div class="mt-3 overflow-hidden rounded-lg border border-neutral-40 bg-secondary-10/10">
  <div class="flex items-center gap-1.5 border-b border-neutral-40 px-2 py-2.5 text-neutral-80">
    <pay-icon [shape]="IconNames.Timer" size="xs" />
    <span class="text-xs uppercase tracking-wider">{{ 'login.last-used-emails' | translate }}</span>
  </div>
  <div class="divide-y divide-neutral-40">
    @for (email of e; track email.uuid) {
    <button
      type="button"
      (click)="emailClickedHandler(email)"
      class="group flex w-full items-center justify-between px-1 py-1 text-left text-neutral-80 transition-colors duration-150 hover:bg-secondary-30/20 hover:text-neutral-100 focus:bg-secondary-30/20 focus:outline-none">
      <div class="flex min-w-0 items-center gap-2.5 pl-1">
        <div
          class="my-2 flex size-6 items-center justify-center rounded-full bg-neutral-8 text-neutral-60 transition-colors duration-150 group-hover:bg-primary-100 group-hover:text-secondary-5">
          <pay-icon [shape]="IconNames.UserAvatar" size="xs" />
        </div>
        <span class="truncate font-heading text-sm">{{ email.email }}</span>
      </div>
      <div class="flex flex-row items-center text-neutral-60 group-hover:text-neutral-100">
        <span class="mx-2 text-xs transition-all duration-300 ease-out group-hover:-translate-x-1">{{ email.lastUsedAt | dateAgo }}</span>

        <div class="z-20 hidden pr-1 hover:text-primary group-hover:block" (click)="emailDeleteClickHandler($event, email.uuid)">
          <pay-icon [shape]="IconNames.TrashCan" size="custom" customSize="h-5 w-5" />
        </div>
      </div>
    </button>
    }
  </div>
</div>
}
